import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import styles from './styles.module.scss'

const ActionBar = React.forwardRef(
  ({ align, className, noBorder, as, ...props }, ref) => {
    // const { controlId } = useContext(FormContext)
    const classes = classNames(className, {
      [styles.actionBar]: true,
      [styles.noBorder]: noBorder,
      [styles.alignStart]: align === 'start',
      [styles.alignEnd]: align === 'end',
    })
    let Component = 'div'
    if (as) Component = as

    return <Component ref={ref} className={classes} {...props} />
  }
)

ActionBar.propTypes = {
  /**
   * The ActionBar `ref` will be forwarded to the underlying element.
   * Unless the ActionBar is rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */
  _ref: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  align: PropTypes.oneOf(['start', 'end']),
}

ActionBar.defaultProps = {
  _ref: null,
  align: 'start',
}

export default ActionBar
